
import { Component, Prop, Vue } from 'vue-property-decorator';

import OrderArea from './components/OrderArea.vue';
import OrderAddress from './components/OrderAddress.vue';
import OrderTopTitle from '@/components/OrderInfo/OrderTopTitle.vue'

import { getAddress } from '@/api/address';
import { sendOut } from '@/api/order';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'OrderSend',
  components: {
    OrderArea,
    OrderAddress,
    OrderTopTitle
  }
})
export default class extends Vue {
  private formSend = {
    area: '',
    reply_address: '',
    reply_name: '',
    reply_mobile: '',
    reply_phone_num: '',
    send_express_number: '',
    send_express_name: '',

    reply_province: '',
    reply_city: '',
    reply_district: '',
    reply_province_name: '',
    reply_city_name: '',
    reply_district_name: '',
    reply_adcode: ''

  }
  private addressList: any = [];
  private addressListJson: string = '';
  private dialogAreaVisible = false;
  private addressVisible = false;
  private orderDetailList:any=[];

  created() {
    this.orderDetailList = JSON.parse(this.$route.query.orderDetailList.toString());
    this.getAddress();
  }

  // 打开选择省市区
  selectArea() {
    this.dialogAreaVisible = true;
  }
  // 选择省市区保存
  selectAreaSave(val:any) {
    this.dialogAreaVisible = false;
    this.formSend.area = val.province_name + val.city_name + val.district_name;
    this.formSend.reply_province = val.province;
    this.formSend.reply_city = val.city;
    this.formSend.reply_district = val.district;
    this.formSend.reply_province_name = val.province_name;
    this.formSend.reply_city_name = val.city_name;
    this.formSend.reply_district_name = val.district_name;
    this.formSend.reply_adcode = val.adcode;
  }
  // 关闭选择省市区
  areaClose(value: boolean) {
    this.dialogAreaVisible = value;
  }

  // 地址选择返回
  addressSelect(val:any) {
    this.addressVisible = false;
    this.formSend.area = val.province_name + val.city_name + val.district_name;
    this.formSend.reply_province = val.province;
    this.formSend.reply_city = val.city;
    this.formSend.reply_district = val.district;
    this.formSend.reply_province_name = val.province_name;
    this.formSend.reply_city_name = val.city_name;
    this.formSend.reply_district_name = val.district_name;
    this.formSend.reply_adcode = '';

    this.formSend.reply_address = val.address;
    this.formSend.reply_name = val.name;
    this.formSend.reply_mobile = val.mobile;
    this.formSend.reply_phone_num = val.phone_num;
    this.formSend.reply_phone_num = val.phone_num;
  }
  // 寄送
  sendHandle() {
    if(!this.formSend.reply_name){
       this.showErrorMsg('请输入寄件人姓名');
      return
    }
    if (this.formSend.reply_mobile && this.formSend.reply_mobile.length > 0&&!(this.formSend.reply_mobile.charAt(0) === '1' && this.formSend.reply_mobile.length === 11)) {
      this.showErrorMsg('请输入正确的手机号码');
      return;
    }
    if (this.formSend.reply_phone_num && this.formSend.reply_phone_num.length > 0&&!(this.formSend.reply_phone_num.length >= 3 && this.formSend.reply_phone_num.length <= 18)) {
      this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
      return;
    }
    if(!this.formSend.reply_mobile&&!this.formSend.reply_phone_num){
       this.showErrorMsg('请输入手机号（手机、电话二选一）');
      return
    }
    if(!this.formSend.reply_address){
       this.showErrorMsg('请输入详细地址');
      return
    }
    if (!this.formSend.send_express_number) {
      this.showErrorMsg('请输入物流单号');
      return;
    }
    if (!this.formSend.send_express_name) {
      this.showErrorMsg('请输入物流公司');
      return;
    }
    let orderTaskIds:any = [];
    this.orderDetailList.forEach((element:any) => {
      if (element && element.order && element.order.task_send) {
        let obj:any = {};
        obj.order_id = element.order.id;
        obj.order_task_id = element.order.task_send.id;
        orderTaskIds.push(obj);
      }
    });
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      order_task_ids: JSON.stringify(orderTaskIds),
      reply_name: this.formSend.reply_name,
      reply_mobile: this.formSend.reply_mobile,
      reply_phone_num: this.formSend.reply_phone_num,
      reply_address: this.formSend.reply_address,
      reply_province: this.formSend.reply_province,
      reply_city: this.formSend.reply_city,
      reply_district: this.formSend.reply_district,
      reply_province_name: this.formSend.reply_province_name,
      reply_city_name: this.formSend.reply_city_name,
      reply_district_name: this.formSend.reply_district_name,
      reply_adcode: this.formSend.reply_adcode,
      send_express_number: this.formSend.send_express_number,
      send_express_name: this.formSend.send_express_name
    };
    sendOut(params)
      .then(res => {
        if ((res as any).code === 0) {
          this.showSecussMsg((res as any).msg);
          this.$store.dispatch('CloseEvaluated', true);
          this.$router.go(-1);
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  // 获取地址列表
  getAddress() {
    const params = {
      user_id: UserModule.getUserId
    };
    getAddress(params)
      .then(res => {
        this.addressList = (res as any).data.list;
        for (let i = 0; i < this.addressList.length; i++) {
          let cont = this.addressList[i];
          cont.isActive = false;
          this.$set(this.addressList, cont, i);
          if (this.addressList[i].is_default === '1') {
            this.addressSelect(this.addressList[i]);
          }
        }
        this.addressListJson = JSON.stringify(this.addressList);
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  showSelectAddress() {
    this.addressVisible = true;
  }
  closeAddressHandle(val:boolean) {
    this.addressVisible = val;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
